var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { key: _vm.errorKey }, [
    _c("span", {
      class: _vm.cssClasses
        ? _vm.cssClasses.error.icon || undefined
        : "panel-error-icon",
      attrs: { "aria-hidden": "true" },
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        class: _vm.cssClasses
          ? _vm.cssClasses.error.item || undefined
          : "panel-error-item",
      },
      [_c("survey-string", { attrs: { locString: _vm.error.locText } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }